function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.999996 11H14.9999C15.5522 11 15.9999 10.5522 15.9999 9.99996V0.999996C15.9999 0.447714 15.5522 0 14.9999 0H0.999996C0.447714 0 0 0.447714 0 0.999996V9.99996C0 10.5522 0.447714 11 0.999996 11ZM1.00008 10.0001V1.00008H15V10.0001H1.00008Z",
  fill: "#96A8BE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99998 7C7.89179 7 7.78653 6.96492 7.69998 6.9L0.200007 1.40003C0.0571013 1.29285 -0.0177696 1.11757 0.00359757 0.94022C0.0249647 0.76287 0.139324 0.610392 0.303596 0.540222C0.467869 0.470051 0.657099 0.49285 0.800005 0.600029L7.99998 5.88001L15.2 0.600029C15.4209 0.434344 15.7343 0.479116 15.8999 0.700029C16.0656 0.920942 16.0209 1.23434 15.7999 1.40003L8.29998 6.9C8.21343 6.96492 8.10816 7 7.99998 7Z",
  fill: "#96A8BE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5005 10.5C15.394 10.4989 15.2907 10.4639 15.2055 10.4L9.0645 5.9C8.89991 5.80301 8.80499 5.6207 8.81989 5.43024C8.83479 5.23978 8.95692 5.07446 9.13459 5.00424C9.31226 4.93403 9.51442 4.97119 9.6555 5.10001L15.7955 9.59999C15.9676 9.72912 16.0379 9.95393 15.9698 10.1581C15.9018 10.3623 15.7107 10.5 15.4955 10.5H15.5005Z",
  fill: "#96A8BE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0.50003 10.5001C0.284816 10.5001 0.0937472 10.3623 0.0256905 10.1582C-0.0423663 9.95401 0.0278599 9.7292 0.200031 9.60007L6.34001 5.10008C6.56285 4.93688 6.87581 4.98524 7.03901 5.20808C7.2022 5.43093 7.15385 5.74388 6.93101 5.90708L0.800029 10.4001C0.713481 10.465 0.608215 10.5001 0.50003 10.5001Z",
  fill: "#96A8BE"
});

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.1bdf1c9b.svg";
export { ForwardRef as ReactComponent };